module.exports = __webpack_public_path__ + "media/fonts/SFProDisplay-Heavy-24136192bce52708c98be192f4c9eeab.woff2";